import React, { useState } from 'react';
import Button from '../button/button.jsx';
import Modal from '../modal/modal.jsx';
import InputAnimated from '../inputAnimated/inputAnimated.jsx';
import './passwordAlert.scss';

const PasswordAlert = ({ isOpen, handleCancel, handleAccept, title, text }) => {
  const [formValues, setFormValues] = useState({
    employee_id: '',
    password: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value
    }));
  };

  const handleResetFormValues = () => {
    setFormValues({ employee_id: '', password: '' });
  };

  // Maneja Enter
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();          // Evita el submit nativo
      handleAccept(formValues);    // Envía como si fuera un submit
      handleResetFormValues();
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleCancel} overlayClick={false}>
      <div className="password-alert" onKeyDown={handleKeyDown}>
        <div className="password-alert-header">
          <h2>{title}</h2>
        </div>

        <div className="password-alert-body">
          <p>{text}</p>
        </div>

        <div className="password-alert-inputs">
          <InputAnimated
            name="employee_id"
            value={formValues.employee_id}
            placeholder="Numero de empleado"
            onChange={handleInputChange}
          />
          <InputAnimated
            name="password"
            value={formValues.password}
            type="password"
            placeholder="Contraseña"
            onChange={handleInputChange}
          />
        </div>

        <div className="password-alert-buttons">
          <Button
            onClick={() => {
              handleCancel();
              handleResetFormValues();
            }}
            text="Cancelar"
            type="button"
          />
          <Button
            onClick={() => {
              handleAccept(formValues);
              handleResetFormValues();
            }}
            text="Continuar"
            type="button"
          />
        </div>
      </div>
    </Modal>
  );
};

export default PasswordAlert;